import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-about-dialog',
  templateUrl: './about-dialog.component.html',
  styleUrls: ['./about-dialog.component.css']
})
export class AboutDialogComponent {
  /**Emettitore dell'evento di chiusura */
  @Output() close = new EventEmitter<void>();

  constructor() { }

  /**Metodo che emette l'evento di chiusura al click sullo sfondo o sul pulsante relativo*/
  onClose() {
    this.close.emit();
  }

}
